import GameModel from "../../GameModel";
import { Settings } from "../../Settings";
import BigNum from "../math/BigNum";

export default class Damage extends GameModel {
    constructor() {
        super();

        /**
         * @constant
         * @type {BigNum}
         */
        this.basePickDamagePerTurn = new BigNum(Settings.damage.baseDamagePerTurn);
        /**
         * This is the end result of the MineDamageLogic calculation.
         * @constant
         * @type {BigNum}
         */
        this.totalPickDamagePerTurn = new BigNum(Settings.damage.baseDamagePerTurn);

        /**
         * The base damage ((basePickDamagePerTurn + baseAdditiveBonusPerTurn) * goldBaseDamageMultiplier)
         * @constant
         * @type {BigNum}
         */
        this.baseDamagePerTurn = new BigNum(1);

        /**
         * The damage from purchasing ore multipliers (multiplied by goldOreDamageMultiplier)
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.oreDamageMultiplier = new BigNum(1);

        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.minedDamageMultiplier = new BigNum(1);

        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.prestigeDamageMultiplier = new BigNum(1);

        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.goldDamageMultiplier = new BigNum(1);

        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.goldBaseDamageMultiplier = new BigNum(1);  // base damage / second value. //////////
        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNumValue}
         */
        this.goldOreDamageMultiplier = new BigNum(1); ////////////
        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNumValue}
         */
        this.goldMinedDamageMultiplier = new BigNum(1);///////
        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNumValue}
         */
        this.goldPrestigeDamageMultiplier = new BigNum(1);/////////////
        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNumValue}
         */
        this.goldDepthDamageMultiplier = new BigNum(1); ///////
        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNumValue}
         */
        this.goldRubyDamageMultiplier = new BigNum(1); ////////
        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNumValue}
         */
        this.goldBlockDamageMultiplier = new BigNum(1);


        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.depthDamageMultiplier = new BigNum(1);

        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.rubyDamageMultiplier = new BigNum(1);

        /**
         * This is a derived value. No save required.
         * @constant
         * @type {BigNum}
         */
        this.blockDamageMultiplier = new BigNum(1);

        /**
         * @constant
         * @type {BigNum}
         */
        this.totalPickDamagePerFrame = new BigNum(1);

        // Initialize damage per frame
        this.totalPickDamagePerFrame.copy(this.totalPickDamagePerTurn);
        this.totalPickDamagePerFrame.divNumber(Settings.time.turnFrames);

        /**
         * @constant
         * @type {BigNum}
         */
        this.working = new BigNum(0);
    }

    /**
     * Given the max number of seconds we want to spend mining a tile, calculate
     * the max health of the tile.
     * @param {number} maxMiningSeconds 
     * @param {BigNum} maxBrickHealthOutput The output param.
     */
    calculateMaxBrickHealth(maxMiningSeconds, maxBrickHealthOutput) {

        // convert the seconds into turns.
        const maxMiningTurns = maxMiningSeconds * Settings.time.turnsPerSecond;

        maxBrickHealthOutput.copy(this.totalPickDamagePerTurn);
        maxBrickHealthOutput.mulNumber(maxMiningTurns);
    }

    /**
     * Given the health of a brick, how long would it take to mine?
     * @param {BigNum} brickHealth 
     * @returns {number}
     */
    calculateMineSeconds(brickHealth) {
        // health * turns/damage = turns to mine

        // Calculate turns
        this.working.copy(brickHealth);
        this.working.div(this.totalPickDamagePerTurn);

        // Convert to seconds
        this.working.mulNumber(Settings.time.secondsPerTurn);

        return this.working.toNumber();
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.resetForPrestige();

        this.baseDamagePerTurn.setValue(1);
        this.oreDamageMultiplier.setValue(1);

        this.minedDamageMultiplier.setValue(1);
        this.prestigeDamageMultiplier.setValue(1);

        this.goldDamageMultiplier.setValue(1);
        this.goldBaseDamageMultiplier.setValue(1);
        this.goldOreDamageMultiplier.setValue(1);
        this.goldMinedDamageMultiplier.setValue(1);
        this.goldPrestigeDamageMultiplier.setValue(1);
        this.goldDepthDamageMultiplier.setValue(1);
        this.goldRubyDamageMultiplier.setValue(1);
        this.goldBlockDamageMultiplier.setValue(1);

        this.depthDamageMultiplier.setValue(1);
        this.rubyDamageMultiplier.setValue(1);
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.basePickDamagePerTurn.setValue(Settings.damage.baseDamagePerTurn);
        this.totalPickDamagePerTurn.setValue(Settings.damage.baseDamagePerTurn);
        this.totalPickDamagePerFrame.setValue(1);

        this.oreDamageMultiplier.setValue(1);
    }
}